import { render, staticRenderFns } from "./CompletedObservationStats.vue?vue&type=template&id=5923f2b5&scoped=true&"
import script from "./CompletedObservationStats.vue?vue&type=script&lang=js&"
export * from "./CompletedObservationStats.vue?vue&type=script&lang=js&"
import style0 from "./CompletedObservationStats.vue?vue&type=style&index=0&id=5923f2b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923f2b5",
  null
  
)

export default component.exports